module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "560",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [(_vm.single) ? [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tchText(_vm.single)))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "课节"
    }
  }, [(_vm.single.manual) ? _c('span', [_vm._v("手动")]) : _c('span', [_vm._v(_vm._s(_vm.single.lessonDate || '') + " " + _vm._s(_vm.single.beginTime || ''))]), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v(_vm._s(_vm.singleMeta(_vm.single)))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "异动类型"
    }
  }, [_c('Tag', {
    attrs: {
      "color": _vm.typeColor(_vm.single.type)
    }
  }, [_vm._v(_vm._s(_vm.typeText(_vm.single.type)))]), _vm._v(" "), (!_vm.single.manual) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("原因：" + _vm._s(_vm.single.reason || '未填写'))]) : _vm._e()], 1), _vm._v(" "), (_vm.single.handled) ? _c('Form-item', {
    attrs: {
      "label": "原跟进"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.resultText(_vm.single.result)))]), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v(_vm._s(_vm.single.handledBy || '') + " " + _vm._s(_vm.single.handledAt || '') + "（提交后覆盖）")])]) : _vm._e()] : _c('Form-item', {
    attrs: {
      "label": "涉及"
    }
  }, [_c('div', [_vm._v("共 " + _vm._s(_vm.lessons.length) + " 节课 · " + _vm._s(_vm.teacherNames))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": _vm.single ? '跟进结果' : '统一结果',
      "required": ""
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.result),
      callback: function($$v) {
        _vm.$set(_vm.form, "result", $$v)
      },
      expression: "form.result"
    }
  }, _vm._l((_vm.resultDict), function(item, code) {
    return _c('Option', {
      key: code,
      attrs: {
        "value": code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": _vm.single ? '跟进备注' : '统一备注'
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 1000,
      "placeholder": _vm.single ? '沟通内容、后续措施、是否影响全勤资格等' : '将写入每一条记录'
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.single ? '提交跟进' : '确认批量跟进'))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79f8d22a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/modal/FollowupHandleModal.vue
// module id = 1882
// module chunks = 8